module.exports = __webpack_public_path__ + "img/admin.2d095a48.svg";